var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimizedMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#1C2F41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8638 39.4323V34.154L13.7938 41.2242C13.655 41.3629 13.4299 41.3629 13.2911 41.2242L11.1041 39.037C10.9653 38.8983 10.9653 38.6731 11.1041 38.5344L18.1741 31.4642H12.8959C12.6997 31.4642 12.5405 31.305 12.5405 31.1088V28.0156C12.5405 27.8193 12.6997 27.6602 12.8959 27.6602L24.3122 27.6603C24.5084 27.6603 24.6676 27.8195 24.6676 28.0157L24.6677 39.4323C24.6677 39.6286 24.5086 39.7877 24.3123 39.7877H21.2192C21.023 39.7877 20.8638 39.6285 20.8638 39.4323Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1558 20.864H39.434C39.6303 20.864 39.7894 21.0232 39.7894 21.2195V24.3126C39.7894 24.5169 39.6263 24.6765 39.4026 24.6667L28.0177 24.6665C27.8134 24.6665 27.6539 24.5048 27.6636 24.2811L27.6635 12.8959C27.6635 12.6996 27.8213 12.5404 28.0175 12.5404H31.1106C31.3069 12.5404 31.4661 12.6996 31.4661 12.8959V18.1742L38.5361 11.1041C38.6748 10.9653 38.9 10.9653 39.0387 11.1041L41.2258 13.2912C41.3645 13.43 41.3645 13.6551 41.2258 13.7939L34.1558 20.864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizedMode);
export default __webpack_public_path__ + "static/media/minimizedMode.2f7192afd8fac908705e6203201b5c1a.svg";
export { ForwardRef as ReactComponent };